module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“"), _c('i', [_vm._v("We can no longer afford an obsolete society of obsolete people")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_vm._v("—P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RESIDENT")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AROLD")]), _vm._v(" K. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORSE")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('i', [_vm._v("Second Inaugural Address")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('i', [_vm._v("January 20, 1988")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495aa1af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 78
// module chunks = 0